
export const Info = () => {
    return (
        <section className="info_section  layout_padding2-top">
            {/* <div className="social_container">
            </div> */}
            <div className="info_container ">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-lg-3">
                            <h6>
                                За нас
                            </h6>
                            <p>
                                QPro Engineering e млада фирма с богат опит, която е съсредоточена в изготвяне на конструктивни решения за Вашия бъдещ проект.
                            </p>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <h6>
                                Проектиране
                            </h6>
                            <p>
                                Нашата фирма е изготвила множество проекти с различно предназначение.
                            </p>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <h6>
                                Свържете с нас
                            </h6>
                            <p>
                                Изпратете запитване на предоставения имейл или се обадете на посочения телефон, за да обсъдим Вашите бъдещи идеи.
                            </p>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <h6>
                                Контакти
                            </h6>
                            <div className="info_link-box">
                                <a href="">
                                    <img src="images/location.png" alt="" />
                                    <span>ул. капитан Димитър Списаревски №3, гр.София </span>
                                </a>
                                <a href="">
                                    <img src="images/call.png" alt="" />
                                    <span>+359 883 38 14 38</span>
                                </a>
                                <a href="">
                                    <img src="images/mail.png" alt="" />
                                    <span> qpro@abv.bg</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}